module.exports = __webpack_public_path__ + "media/src/images/partners/padova-88139287c7f7e63642bcb966bd84cfbd.jpg";